import React from 'react';
import './BottomActionBar.css';

interface BottomActionBarProps {
  onExportPdf: () => void;
  onQuitter: () => void;
  onDeposer: () => void;
  canDeposer: boolean;
}

const BottomActionBar: React.FC<BottomActionBarProps> = ({
  onExportPdf,
  onQuitter,
  onDeposer,
  canDeposer,
}) => {
  return (
    <div className="bottom-action-bar">
      <button
        type="button"
        className="bottom-action-bar__btn-dark"
        onClick={onExportPdf}
      >
        PDF
      </button>
      <button
        type="button"
        className="bottom-action-bar__btn-dark"
        onClick={onQuitter}
      >
        Quitter
      </button>
      <button
        type="button"
        className="bottom-action-bar__btn-primary"
        disabled={!canDeposer}
        onClick={onDeposer}
      >
        Candidater &amp; signer
      </button>
    </div>
  );
};

export default BottomActionBar;
